import React, { useState } from 'react';
import { Bell, AlertCircle, Phone, FileText, Package, UserX, RefreshCw } from 'lucide-react';
import { useData } from '../context/DataContext';
import { toast } from 'sonner';

import { useT } from '../context/LanguageContext';
const iconFor = (t) => {
  if (t === 'APK') return AlertCircle;
  if (t === 'Betaling') return FileText;
  if (t === 'Terugbel') return Phone;
  if (t === 'Onderdeel') return Package;
  if (t === 'Slapend') return UserX;
  return Bell;
};

export default function Meldingen({ onNavigate }) {


  const { t, lang } = useT();  const { meldingen, refreshMeldingen } = useData();
  const [filter, setFilter] = useState('alle');

  const filtered = meldingen.filter(m => filter === 'alle' || m.type.toLowerCase() === filter);
  const counts = meldingen.reduce((acc, m) => { acc[m.type] = (acc[m.type] || 0) + 1; return acc; }, {});

  const tabs = [
    { key: 'alle', label: t('Alle'), count: meldingen.length },
    { key: 'apk', label: 'APK', count: counts['APK'] || 0 },
    { key: 'betaling', label: t('Betalingen'), count: counts['Betaling'] || 0 },
    { key: 'terugbel', label: t('Terugbel', 'Terugbel'), count: counts['Terugbel'] || 0 },
    { key: 'onderdeel', label: t('nav.parts'), count: counts['Onderdeel'] || 0 },
    { key: 'slapend', label: t('Slapend', 'Slapend'), count: counts['Slapend'] || 0 }
  ];

  return (
    <div>
      <div className="cs-page-header">
        <div><h2>{t('page.alerts.title')}</h2><p>{meldingen.length} {t('actieve meldingen die aandacht vragen', 'actieve meldingen die aandacht vragen')}</p></div>
        <button className="cs-btn primary" onClick={async () => {
          try { const r = await refreshMeldingen(); toast.success(`${r.count} ${t('meldingen ververst', 'meldingen ververst')}`, { description: `APK: ${r.apk} · ${t('Betaling','Betaling')}: ${r.betaling} · ${t('Slapend', 'Slapend')}: ${r.slapend}` }); }
          catch { toast.error(t('Verversen mislukt')); }
        }}><RefreshCw size={14} /> {t('Meldingen verversen', 'Meldingen verversen')}</button>
      </div>

      <div className="cs-tabs">
        {tabs.map(tb => (
          <button key={tb.key} className={`cs-tab ${filter === tb.key ? 'active' : ''}`} onClick={() => setFilter(tb.key)}>
            {tb.label} <span className="cs-badge gray" style={{ marginLeft: 6 }}>{tb.count}</span>
          </button>
        ))}
      </div>

      <div className="cs-card">
        <table className="cs-table">
          <thead><tr><th>{t('Type')}</th><th>{t('Melding')}</th><th>{t('Klant')}</th><th>{t('Kenteken')}</th><th>{t('Datum')}</th><th>{t('Prioriteit')}</th></tr></thead>
          <tbody>
            {filtered.map(m => {
              const Icon = iconFor(m.type);
              return (
                <tr key={m.id} onClick={() => onNavigate && onNavigate('klanten')}>
                  <td><Icon size={14} style={{ verticalAlign: 'middle', color: 'var(--cs-amber)', marginRight: 6 }} />{t(m.type, m.type)}</td>
                  <td style={{ fontWeight: 600 }}>{t(m.titel, m.titel)}</td>
                  <td>{m.klant}</td>
                  <td style={{ fontFamily: 'ui-monospace, monospace' }}>{m.kenteken || '-'}</td>
                 <td>{new Date(m.datum).toLocaleDateString(lang === 'en' ? 'en-GB' : 'nl-NL')}</td>
                  <td><span className={`cs-badge ${m.prioriteit === 'hoog' ? 'red' : m.prioriteit === 'midden' ? 'amber' : 'gray'}`}>{t(m.prioriteit, m.prioriteit)}</span></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
